// Íconos de trazo, decorativos (aria-hidden). Los botones que solo tienen ícono llevan su propio aria-label.
import type { ReactElement } from 'react';

type IconProps = { size?: number };

function Svg({ size = 18, children }: IconProps & { children: ReactElement | ReactElement[] }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      {children}
    </svg>
  );
}

export const IconCalendar = (p: IconProps) => <Svg {...p}><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4M8 3v4M3 10h18" /></Svg>;
export const IconPin = (p: IconProps) => <Svg {...p}><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" /></Svg>;
export const IconShare = (p: IconProps) => <Svg {...p}><path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7" /><path d="M12 3v13" /><path d="M7 8l5-5 5 5" /></Svg>;
export const IconPoll = (p: IconProps) => <Svg {...p}><path d="M5 20V10M12 20V4M19 20v-7" /></Svg>;
export const IconQuestion = (p: IconProps) => <Svg {...p}><path d="M21 12a8 8 0 0 1-11.8 7L4 20l1.1-4.6A8 8 0 1 1 21 12z" /></Svg>;
export const IconWords = (p: IconProps) => <Svg {...p}><path d="M4 8h9M4 13h16M4 18h11" /></Svg>;
export const IconCheck = (p: IconProps) => <Svg {...p}><path d="M5 12.5l4.5 4.5L19 7.5" /></Svg>;
export const IconClose = (p: IconProps) => <Svg {...p}><path d="M6 6l12 12M18 6L6 18" /></Svg>;
